import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "w-full overflow-y-auto rounded-lg bg-eblack-100/70" };
const _hoisted_2 = { class: "flex flex-col w-full gap-4 p-2" };
const _hoisted_3 = {
    key: 1,
    class: "flex flex-col w-full gap-2 p-4 text-sm text-red-600 bg-white border border-red-200 rounded-lg"
};
const _hoisted_4 = {
    key: 2,
    class: "flex flex-col w-full gap-4 p-4 bg-white border rounded-lg"
};
const _hoisted_5 = { class: "relative flex justify-between" };
const _hoisted_6 = { class: "flex flex-col gap-0.5" };
const _hoisted_7 = { class: "text-sm font-medium" };
const _hoisted_8 = { class: "text-xs" };
const _hoisted_9 = { class: "font-semibold text-yellow-500" };
const _hoisted_10 = { class: "flex justify-between w-full text-sm" };
const _hoisted_11 = { class: "flex flex-col gap-1 text-eblack-700" };
const _hoisted_12 = { class: "flex flex-col gap-1 text-right text-eblack-700" };
const _hoisted_13 = { key: 0 };
const _hoisted_14 = {
    key: 0,
    class: "flex flex-col gap-1 pt-2 mt-1 text-xs border-t text-eblack-600"
};
import { computed } from "vue";
import { useCustomerItineraries } from "@/domains/itinerary/composables/useCustomerItineraries";
// ---------------------------------------------------------------------------
// Props
// ---------------------------------------------------------------------------
export default /*@__PURE__*/ _defineComponent({
    __name: 'ItinerariesTab',
    props: {
        customerId: {}
    },
    setup(__props) {
        const props = __props;
        // ---------------------------------------------------------------------------
        // Data
        // ---------------------------------------------------------------------------
        const { customerItineraries, isLoading, error } = useCustomerItineraries(computed(() => props.customerId || null));
        // ---------------------------------------------------------------------------
        // Helpers
        // ---------------------------------------------------------------------------
        function formatDate(dateStr) {
            if (!dateStr)
                return "—";
            const d = new Date(dateStr);
            if (isNaN(d.getTime()))
                return "—";
            return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
        }
        function firstSlotDate(itinerary, kind) {
            const slots = itinerary.slots_itineraries;
            if (!slots || slots.length === 0)
                return undefined;
            const field = kind === "start" ? "start_date" : "end_date";
            return slots[0].service_slot?.[field];
        }
        function lastSlotDate(itinerary, kind) {
            const slots = itinerary.slots_itineraries;
            if (!slots || slots.length === 0)
                return undefined;
            const field = kind === "start" ? "start_date" : "end_date";
            return slots[slots.length - 1].service_slot?.[field];
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_unref(isLoading))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
                            return _createElementVNode("div", {
                                key: n,
                                class: "flex flex-col w-full gap-3 p-4 bg-white border rounded-lg animate-pulse"
                            }, [...(_cache[0] || (_cache[0] = [
                                    _createElementVNode("div", { class: "w-1/3 h-4 rounded bg-eblack-200" }, null, -1),
                                    _createElementVNode("div", { class: "w-1/2 h-3 rounded bg-eblack-200" }, null, -1),
                                    _createElementVNode("div", { class: "w-2/3 h-3 rounded bg-eblack-200" }, null, -1)
                                ]))]);
                        }), 64))
                        : (_unref(error))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("p", null, "Error al cargar los servicios contratados.", -1)
                                ]))]))
                            : (_unref(customerItineraries).length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[2] || (_cache[2] = [
                                        _createElementVNode("p", { class: "text-sm text-eblack-500" }, " No ha contratado nuestros servicios. ", -1)
                                    ]))]))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_unref(customerItineraries), (itinerary) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: itinerary.id,
                                        class: "flex flex-col w-full gap-4 p-4 bg-white border rounded-lg"
                                    }, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("span", _hoisted_7, "# " + _toDisplayString(itinerary.id), 1),
                                                _createElementVNode("p", _hoisted_8, [
                                                    _cache[3] || (_cache[3] = _createTextVNode(" Estado: ", -1)),
                                                    _createElementVNode("span", _hoisted_9, _toDisplayString(itinerary.state), 1)
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("span", null, "Inicio: " + _toDisplayString(formatDate(firstSlotDate(itinerary, "start"))), 1),
                                                _createElementVNode("span", null, "Fin: " + _toDisplayString(formatDate(lastSlotDate(itinerary, "end"))), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                                _createElementVNode("span", null, "Servicios: " + _toDisplayString(itinerary.slots_itineraries?.length ?? 0), 1),
                                                (itinerary.total != null)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Total: $" + _toDisplayString(itinerary.total), 1))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]),
                                        (itinerary.slots_itineraries &&
                                            itinerary.slots_itineraries.length > 0)
                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itinerary.slots_itineraries, (slot) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: slot.id,
                                                        class: "flex items-center gap-1"
                                                    }, [
                                                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "w-1.5 h-1.5 rounded-full bg-eorange-400 flex-shrink-0" }, null, -1)),
                                                        _createTextVNode(" " + _toDisplayString(slot.service?.name ?? "Servicio"), 1)
                                                    ]));
                                                }), 128))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 128))
                ])
            ]));
        };
    }
});
